import Ext from 'Ext'
import messageResource from '../../../messageResource'
import GradientButton from "../../../controls/at_gradient_button";
import {SmartGroupsSelectorPanel} from "../../../controls/at_groups_selector_panel";

const ExtendedGroupsSelectorPanel = Ext.extend( SmartGroupsSelectorPanel, {

    cls: "selector-panel userGroupsSelector extended",

    cancelButtonLabelKey: "user_groups_selector.cancel_button.label",

    initComponent: function ()
    {
        ExtendedGroupsSelectorPanel.superclass.initComponent.call( this );
        this.optionValueInit = this.optionValue;

        if ( this.customOnChangeHandler )
            this.on( "change", this.customOnChangeHandler, this );
    },

    createFooterButtons: function() {
        ExtendedGroupsSelectorPanel.superclass.createFooterButtons.call(this);

        this.cancelButton = new GradientButton({
                                                      text: messageResource.getMessage(this.cancelButtonLabelKey),
                                                      minWidth: 60,
                                                      cls: "greyButton close-button cancel-button"
                                                  });
    },

    onCancelButtonClick: function () {
        this.resetState(true);
        this.fireEvent("close");
    },

    getFooterSection: function() {
        var res = ExtendedGroupsSelectorPanel.superclass.getFooterSection.call(this);
        return [this.cancelButton].concat(res);
    },

    getSelectedGroupIds: function (getValuesGroupsIfAll)
    {
        if( this.currentOption.inputValue == this.allItemsOptionValue && !getValuesGroupsIfAll)
            return null;

        var result = [];
        var selection = this.getSelection();
        for( var i = 0; i < selection.length; i++ )
        {
            var groupDataBean = selection[i];
            result.push( groupDataBean.id );
        }

        return result;
    },

    getSelectedGroupIdsSet: function (getValuesGroupsIfAll)
    {
        var groupIdSet = {};
        var groupIdsArray = this.getSelectedGroupIds(getValuesGroupsIfAll);

        if (groupIdsArray==null)
            return groupIdSet;

        for( var i = 0; i < groupIdsArray.length; i++ )
        {
            groupIdSet[groupIdsArray[i]]=true;
        }

        return groupIdSet;
    },

    updateState: function() {
        this.selectOption(this.optionValue);
    },

    setAllIfNoneSelected: function ()
    {
        if( this.getSelectedGroupIds() && this.getSelectedGroupIds().length == 0  && this.currentOption.inputValue == this.customOptionValue )
            this.selectOption(this.allItemsOptionValue);
    }
} );

export default ExtendedGroupsSelectorPanel



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/at_extended_groups_selector_panel.js